import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import '../../assets/css/digitalLetterStyles.css'
import { clearAll, setActiveEmailTab } from '../../config/redux/slice/appSlice'
import BankWrapper from '../layout/BankWrapper'
import TransfereeWrapper from '../layout/TransfereeWrapper'
import DigitalLetterSidebar from '../pages/DigitalLetter/DigitalLetterSidebar'
import AppWrapper from '../layout/AppWrapper'
import NotapWrapper from '../layout/NotapWrapper'
import GeneralWrapper from '../layout/GeneralWrapper'
import { appUrls } from '../../utils/urls/appUrls'

export default function DigitalLetterWrapper({children}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();
    const {
        token,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

    useEffect(()=>{
      dispatch(clearAll())
    }, [])
    
    const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
      if(searchParams.get('tab') == 'inbox'){
          dispatch(setActiveEmailTab({name: 'inbox'}))
      } else if(searchParams.get('tab') == 'draft'){
          dispatch(setActiveEmailTab({name: 'draft'}))
      } else if(searchParams.get('tab') == 'sent'){
          dispatch(setActiveEmailTab({name: 'sent'}))
      }else if(searchParams.get('tab') == 'compose'){
          dispatch(setActiveEmailTab({name: 'compose'}))
      }
      else{
          if(token && token != ''){
            dispatch(setActiveEmailTab({name: 'inbox'}))
          }
      }
    }, [searchParams.get('tab')]); // eslint-disable-line
    
  return (
    //   <>{user_role == 'BANK_USER' ?
    //   <BankWrapper pageTitle={'Digital Letter Management'}>
    //     <WrapperChildrenLetter>{children}</WrapperChildrenLetter>
    // </BankWrapper>
    //   : 
    //   user_role == 'TRANSFEREE_USER' ?
    //   <TransfereeWrapper pageTitle={'Digital Letter Management'}>
    //     <WrapperChildrenLetter>{children}</WrapperChildrenLetter>
    // </TransfereeWrapper> :
    // <NotapWrapper pageTitle={'Digital Letter Management'}>
    //   <WrapperChildrenLetter>{children}</WrapperChildrenLetter>
    // </NotapWrapper>
    // }</>
    <>
    <GeneralWrapper pageTitle={'Digital Letters Module'}>
      <WrapperChildrenLetter>{children}</WrapperChildrenLetter>
    </GeneralWrapper>
    </>
  )
}

   function WrapperChildrenLetter({children}){
    return (
        <div className="email-wrapper rounded border bg-white">
        <div className="email-wrapper-child row no-gutters justify-content-center">
            <DigitalLetterSidebar/>
            <div className="col-lg-8 col-xl-9 col-xxl-10">
              {children}
            </div>
          </div>
        </div> 
  )
   } 
